import { extPost, extPut } from '../../../../dataSource/requests';
import { API_URL } from '../../../../utils/constants';
import { getAccessToken } from '../../../../utils/users';

export const updateFiles = ({ url, fileList, id }) => {
  const formData = new FormData();

  fileList.forEach((file) => {
    if (file.id) {
      formData.append('attachmentsId', file.id);
    } else {
      formData.append('newAttachments', file.originFileObj);
    }
  });

  formData.append('id', id);

  return extPut({
    url: API_URL + url,

    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },

    params: formData,
  });
};

export const updateFilesRel = ({ url, fileList, id }) => {
  const formData = new FormData();

  fileList.forEach((file) => {
    if (file.id) {
      formData.append('attachmentsId', file.id);
    } else {
      formData.append('newAttachments', file.originFileObj);
    }
  });

  formData.append('id', id);

  return extPost({
    url: API_URL + url,

    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },

    params: formData,
  });
};

export const uploadFiles = ({ url, fileList, id }) => {
  const formData = new FormData();

  formData.append('files', fileList.originFileObj);

  fileList.forEach((file) => {
    formData.append('files', file.originFileObj);
  });

  formData.append('id', id);

  return extPost({
    url: API_URL + url,

    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },

    params: formData,
  });
};

export const UploadFilesReports = ({ url, fileList, id }) => {
  const formData = new FormData();

  fileList.forEach((file) => {
    if (file.id) {
      formData.append('attachmentsId', file.id);
    } else {
      formData.append('newAttachments', file.originFileObj);
    }
  });

  formData.append('id', id);

  return extPost({
    url: API_URL + url,

    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },

    params: formData,
  });
};
